
import { Backdrop, Box, CircularProgress, Modal } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { isEmptyDash } from "../../constant";
import { onboardingServices } from "../../services/onboardingServices";
import AlertComponent from "../alert/alert";
import FileViewerModal from "./viewModal";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DownloadIcon from '@mui/icons-material/Download';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  padding: "13px 16px",
};
const MediaListModal = (props) => {
  const [files, setFiles] = useState([]);
  const [fileSrc, setFileSrc] = useState();
  const [fileExtension, setFileExtension] = useState("");
  const [fileName, setFileName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {

  }, []);

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleCloseLoader = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const closeUploadModal = () => {
    props.closeMediaListModal();
  }

  const addFile = (e) => {
    e.preventDefault();
    let fileData = e.target.files[0];
    setFiles(fileData);
  };

  const uploadFile = (e) => {
    e.preventDefault();
    if (isEmptyDash(files)) {
      openAlert(true, "error", `Please select a file.`);
      return;
    }
    let formData = new FormData();
    formData.append("file", files);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success == true) {
          // addFileInList(response?.data?.data, files);
          props?.onUploadMedia(response?.data?.data, props?.uploadObj, files);
          openAlert(true, "success", `${response?.data?.message}`);
          setFiles(null);
          document.getElementById("checklist-fileInput").value = null;
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getFileExtension = (filename) => {
    return filename.split(".").pop();
  }

  const closeModal = () => {
    setFileSrc();
    setIsModalOpen(false);
  };

  const viewMedia = (data, fileNameParam) => {
    // let data1 = encodeKey(data) 
    onboardingServices.viewUrlData(data, fileNameParam).then(function (response) {
      setFileSrc(response?.data?.data?.url);
      const url = response?.data?.data?.url;
      const filename1 = url?.substring(url.lastIndexOf("/") + 1);
      const filename = filename1?.split("?")[0];
      const extension = getFileExtension(filename);
      setFileExtension(extension);
      setFileName(fileNameParam);
      if (
        extension &&
        (extension == "png" ||
          extension == "jpg" ||
          extension == "jpeg" ||
          extension == "pdf")
      ) {
        setIsModalOpen(true);
      } else {
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileNameParam;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(error => console.error('Error downloading Doc:', error));
      }
    });

  };

  const deleteFile = (index, key, idx) => {
    props.deleteFile(index, key, idx);
  }

  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };


  return (
    <>
      {/* Upload Modal */}
      <Modal
        open={props?.isMediaListModalOpen}
        onClose={closeUploadModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box sx={style} className="react_sucess_modal_listing">
          <div className="modal-header">
            <h5 className="modal-title" id="contactModalLabel">
              {props?.uploadObj?.headName === 'GSTIN No.' ? (
                <span>Declaration of GST Non-Enrollment</span>
              ) : (
                <span>{props?.uploadObj?.headName}</span>
              )}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closeUploadModal}
            ></button>
          </div>
          <div className="text-center">
            {(props?.uploadObj?.isUploadOption == true) && <div className="row">
              <div className="col-md-6 lets_onboarding_wizard_react">
                {!isEmptyDash(props?.stepStatus !== 'Approved') && (
                  <div className="">
                    <div className="mb-3 upload-sec-files">
                      <input
                        className="form-control form-h choose"
                        type="file"
                        id="checklist-fileInput"
                        multiple={false}
                        accept={props?.uploadObj?.validation[0]?.fileTypes}
                        onChange={addFile}
                      />
                      {/* <button onClick={uploadFile} className="file-upload-btn"> Upload </button> */}
                      <button onClick={uploadFile} className="file-upload-btn" disabled={isLoading}>
                        {isLoading ? "Uploading..." : "Upload"}
                      </button>
                      {/* {(!isEmptyDash(props?.uploadObj?.template)) && <button onClick={() => viewMedia(props?.uploadObj?.template[0]?.key, props?.uploadObj?.template[0]?.fileName)} className="file-upload-btn" title="Download Template">
                      <DownloadIcon />
                    </button>} */}
                    </div>
                  </div>
                )}
                {!isEmptyDash(props?.uploadObj?.template) && !isEmptyDash(props?.stepStatus !== 'Approved') && (
                  <div className="">
                    <span style={{ paddingRight: '2px' }}>Download Template</span>
                    <DownloadIcon style={{ cursor: 'pointer' }}
                      onClick={() => viewMedia(props?.uploadObj?.template[0]?.key, props?.uploadObj?.template[0]?.fileName)}
                    />
                  </div>
                )}
              </div>
              {/* <div className="col-md-6 lets_onboarding_wizard_react"></div> */}

            </div>}

            <div className="modal-body download-list-modal">
              <form id="employeeForm">
                {(props?.uploadObj?.files?.length > 0) ? <>
                  <table className="table" id="employeeTable">
                    <thead className="">
                      <tr>
                        <th className="vendor_tabels">S.No.</th>
                        <th className="vendor_tabels">Document Name</th>
                        <th className="vendor_tabels">Preview</th>
                        {!isEmptyDash(props?.stepStatus !== 'Approved') && (
                          <th className="vendor_tabels">Delete</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>

                      {props?.uploadObj?.files?.map((ele, index) => (

                        <tr key={index} >
                          <td className="maine_tr_vendors">{index + 1}</td>
                          <td className="maine_tr_vendors">{ele?.name}</td>
                          <td className="maine_tr_vendors">

                            <RemoveRedEyeIcon className="remove_icon_react_block_body" onClick={() => viewMedia(ele?.key, ele?.name)} />
                          </td>
                          {!isEmptyDash(props?.stepStatus !== 'Approved') && (
                            <td>
                              <DeleteOutlineIcon
                                className="delete_icon_react_block_body"
                                onClick={() => deleteFile(index, ele?.key, props?.uploadObj?.idx)}
                              /></td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
                  : <div>
                    No data found
                  </div>}

              </form>
            </div>
          </div>
        </Box>

      </Modal >

      <FileViewerModal
        fileSrc={fileSrc}
        isOpen={isModalOpen}
        onClose={closeModal}
        fileExtension={fileExtension}
        isSubmitCondition={false}
        fileName={fileName}
      />
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseLoader}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default MediaListModal;